import { DateTime } from "luxon";
import type { AttachmentDto } from "../api/types";

export type AttachmentMonthGroup = {
  month: string;
  attachments: AttachmentDto[];
};

const UNKNOWN_MONTH = "Unknown Date";

export const groupAttachmentsByMonth = (
  attachments: AttachmentDto[],
): AttachmentMonthGroup[] => {
  const grouped: Record<string, AttachmentDto[]> = {};
  for (const att of attachments) {
    const date = DateTime.fromISO(att.createdAt);
    const monthYear = date.isValid ? date.toFormat("MMMM yyyy") : UNKNOWN_MONTH;
    if (!grouped[monthYear]) {
      grouped[monthYear] = [];
    }
    grouped[monthYear].push(att);
  }

  const sortedKeys = Object.keys(grouped).sort((a, b) => {
    if (a === UNKNOWN_MONTH) return 1;
    if (b === UNKNOWN_MONTH) return -1;
    const dateA = DateTime.fromFormat(a, "MMMM yyyy");
    const dateB = DateTime.fromFormat(b, "MMMM yyyy");
    return dateB.toMillis() - dateA.toMillis();
  });

  return sortedKeys.map((key) => ({
    month: key,
    attachments: [...grouped[key]].sort(
      (a, b) =>
        DateTime.fromISO(b.createdAt).toMillis() -
        DateTime.fromISO(a.createdAt).toMillis(),
    ),
  }));
};
